module.exports = __webpack_public_path__ + "img/ecommerce.7df7e94c.jpeg";